import siFetch from "api/fetch";

const signIn = (init = null) => siFetch("/api/v1/users/login", init);

export default signIn;
